import { BreakpointKey, HoneycombThemeBase } from '../../types';

export function up(theme: HoneycombThemeBase) {
    return (breakpoint: BreakpointKey | number) => {
        const value = typeof breakpoint === 'string' ? theme.breakpoints.values[breakpoint] : breakpoint;
        return `@media (min-width: ${value}px)`;
    };
}

export function down(theme: HoneycombThemeBase) {
    return (breakpoint: BreakpointKey | number) => {
        const value = typeof breakpoint === 'string' ? theme.breakpoints.values[breakpoint] : breakpoint;
        return `@media (max-width: ${value - 1}px)`;
    };
}

export function between(theme: HoneycombThemeBase) {
    return (minBreakpoint: BreakpointKey | number, maxBreakpoint: BreakpointKey | number) => {
        const minValue = typeof minBreakpoint === 'string' ? theme.breakpoints.values[minBreakpoint] : minBreakpoint;
        const maxValue = typeof maxBreakpoint === 'string' ? theme.breakpoints.values[maxBreakpoint] : maxBreakpoint;
        return `@media (min-width: ${minValue}px) and (max-width: ${maxValue - 1}px)`;
    };
}

export function getSortedKeys(theme: HoneycombThemeBase) {
    return (keys: BreakpointKey[]) => {
        const { keys: breakpointKeys } = theme.breakpoints;
        return keys.sort((a, b) => breakpointKeys.indexOf(a) - breakpointKeys.indexOf(b));
    };
}
